import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fpgFilterItem flat-form"
}
const _hoisted_2 = { class: "fpgFilterItem-date__content" }
const _hoisted_3 = {
  key: 1,
  class: "dt__filter-content-selectBlock-elem"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  y: "1.11133",
  width: "1",
  height: "12",
  rx: "0.5",
  transform: "rotate(-45 0 1.11133)",
  fill: "#EAEDF0"
}, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("rect", {
  x: "8.48535",
  y: "0.40332",
  width: "1",
  height: "12",
  rx: "0.5",
  transform: "rotate(45 8.48535 0.40332)",
  fill: "#EAEDF0"
}, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!

  return ($props.mode === 'filter')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["fpgFilterItem-date", {'fpgFilterItem-date_hidden' : !$data.showAll}])
        }, [
          _createElementVNode("div", {
            class: "fpgFilterItem-date__header",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.showAll = !$data.showAll))
          }, _toDisplayString(this.filter.label), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_date_picker, {
              modelValue: $options.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($options.value) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ])
        ], 2 /* CLASS */)
      ]))
    : ($props.filter.hasValue())
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (this.value.mode === 'all_time')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "За все время"))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, " c " + _toDisplayString(_ctx.moment(this.value.interval.start).format("L LTS")) + "  до " + _toDisplayString(_ctx.moment(this.value.interval.end).format("L LTS")), 1 /* TEXT */)),
          (_openBlock(), _createElementBlock("svg", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.remove())),
            width: "10",
            height: "10",
            viewBox: "0 0 10 10",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_8))
        ]))
      : _createCommentVNode("v-if", true)
}